import { render, staticRenderFns } from "./LocalInfo.vue?vue&type=template&id=5c3417c3"
import script from "./LocalInfo.vue?vue&type=script&lang=js"
export * from "./LocalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports